// extracted by mini-css-extract-plugin
export default {"removeButtonContainer":"RemoveButton_removeButtonContainer__lXSLX","buttonWrapper":"RemoveButton_buttonWrapper__NkKS8","buttonText":"RemoveButton_buttonText__jQIaY"};